var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasValidCoupon)?_c('div',{class:_vm.classList},[_c('span',{staticClass:"plan-coupon-svg"}),_vm._v(" "),_c('span',{staticClass:"coupon-off-text",class:[_vm.ftcCompliancePickAPlanEnabled ? '-ftc' : '']},[_vm._v("\n        "+_vm._s(_vm.couponString)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }